<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="卡号:">
                    <el-input class="s-input" v-model="queryParams.card_no" placeholder="请输入用户id" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机号:">
                    <el-input class="s-input" v-model="queryParams.phone" placeholder="请输入手机号"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="选择充值状态:">
                    <el-select v-model="queryParams.state" placeholder="请选择充值状态" clearable @change="changeQuery">
                        <el-option label="已充值" :value="2"></el-option>
                        <el-option label="待充值" :value="0"></el-option>
                        <el-option label="充值失败" :value="-1"></el-option>
                    </el-select>
                </el-form-item>
                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
            </el-form>
            <div style="margin: 10px 0">
                <el-button type="primary" @click="exportFile">导出</el-button>
                <el-button type="primary" @click="dialogVisibleImport=true">导入</el-button>
            </div>
            <el-table @select="selectgoods" @select-all="selectgoods" v-loading="loading" element-loading-text="数据加载中" stripe border :data="pageInfo.list">
                <el-table-column type="selection"></el-table-column>
                <el-table-column label="ID" prop="id" width="100" align="center"></el-table-column>
                <el-table-column label="注册手机号" prop="user.phone" width="120" align="center"></el-table-column>
                <el-table-column label="转存单号" prop="ordersn" width="auto" align="center"></el-table-column>
                <el-table-column label="转存卡号" prop="card_no" width="180" align="center"></el-table-column>
                <el-table-column label="充值金额" prop="amount" width="150" align="center"></el-table-column>
                <el-table-column label="充值状态" prop="state" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.state === 0">未充值</el-tag>
                        <el-tag type="success" v-if="scope.row.state === 2">已充值</el-tag>
                        <el-tag type="warning" v-if="scope.row.state === -1">充值失败</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="备注" prop="remark" width="180" align="center">
                </el-table-column>
                <el-table-column label="充值时间" prop="recharge_time_str" width="180" align="center"></el-table-column>
                <el-table-column label="创建时间" prop="created_str" width="180" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="170" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑
                        </el-button>
                        <!--<el-button type="text" icon="el-icon-edit" @click="xiangqi(scope.$index, scope.row)">详情
                        </el-button>
                        <el-button v-if="scope.row.state === 2" type="text" class="red" @click="state(scope.row, 1)">禁用
                        </el-button>
                        <el-button v-if="scope.row.state === 0" type="text" class="green" @click="state(scope.row, 2)">
                            启用
                        </el-button>-->
                    </template>
                </el-table-column>
            </el-table>

            <!-- 上线、下线提示框 -->
            <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
                <div class="del-dialog-cnt">{{ confirmContent }}</div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="confirmVisible = false">取 消</el-button>
                    <el-button type="primary" @click="stateData">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 新增 编辑 -->
            <el-dialog :title="title" :visible.sync="addVisible" width="600px" v-if="addVisible" class="dialog_box">
                <el-form ref="form" :model="form" label-width="120px" :rules="rules" label-position="left">
                    <el-form-item label="默认卡号 " prop="card_no">
                        <el-input v-model="form.card_no" placeholder="请输入卡号"></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="phone">
                        <el-input v-model="form.amount" placeholder="请输入金额" ></el-input>
                    </el-form-item>


                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveData">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum"/>
        </div>


        <!-- 导入数据库 -->
        <el-dialog :visible.sync="dialogVisibleImport" width="1000px" @close="upclose">
            <el-form ref="upform" :model="headers" label-width="80px">
                <el-form-item label="文件:">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        :action="uploadUrl"
                        :file-list="fileList"
                        :auto-upload="false">
                        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传.xlsx文件，且不超过2MB</div>
                        <el-divider></el-divider>
                        <div>
                            【导出表格】的格式已与【导入表格】的格式一致，请勿修改列顺序；
                            <br>表格格式如下：
                            <br>
                            1. 已处理的充值单再次提交无效，只会更新备注列信息
                            <br>
                            2. <span class="warning-text">充值单号列作为查找充值单的唯一标识</span>，请勿重复填写，请勿重复提交，
                            <br>
                            3. 充值状态为 ：充值失败时，不会修改用户账户余额，且需输入备注信息；
                            <br>
                            4. <span class="warning-text">充值面额列输入的金额无效，仅作展示用</span>，如果需要修改充值金额，请在右侧操作栏点击编辑当前行的充值金额。
                            <br>
                            5. <span class="warning-text">充值卡号列输入的卡号无效，仅作展示用</span>，如果需要修改卡号，请在右侧操作栏点击编辑当前行的卡号。
                            <el-table :data="exampleTableHeaderData" border style="width: 100%">
                                <!-- 序号 -->
                                <el-table-column prop="ordersn" label="转存单号" width="auto"></el-table-column>
                                <el-table-column prop="card_no" label="默认卡号" width="100"></el-table-column>
                                <el-table-column prop="amount" label="充值面额" width="100"></el-table-column>
                                <el-table-column prop="state" label="充值状态" width="100"></el-table-column>
                                <el-table-column prop="remark" label="备注" width="auto"></el-table-column>

                            </el-table>
                        </div>
                    </el-upload>
                </el-form-item>

            </el-form>
            <div slot="footer">
                <el-button type="primary" @click="submitUpload">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 导入提示信息 -->
        <el-dialog :visible.sync="uplosuccess" width="600px" title="以下数据导入失败">
            <div class="html_box">
                <div v-html="uphtml"></div>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="uplosuccess = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import {request} from '@/common/request';
import {deal} from '@/common/main';
import loadEvents from '@/utils/loading'
import {IMAGE_UPLOAD_PRO_URL} from "@/common/const";

let loads = new loadEvents();
export default {
    name: 'StoreInfo',
    components: {
        Breadcrumb,
        Pagination,
    },
    data() {
        return {
            IMAGE_UPLOAD_PRO_URL: IMAGE_UPLOAD_PRO_URL,
            defaultImg: require('../../assets/img/zhan.jpeg'),
            queryTagParams: {},
            confirmVisible: false,
            confirmContent: '',
            menuList: ['客户', '饭卡转存'],
            title: '加载中',
            addVisible: false,
            selectionList: [], //选中客户
            mode: 'add',
            //关联分销商
            distributorVisible: false,
            distributorList: [],
            selectDistributor: {},
            form: {
                state: 1
            },
            //验证规则
            rules: {
                state: [{
                    required: true,
                    message: '状态不能为空',
                    trigger: 'blur'
                }],
                phone: [{
                    required: false,
                    message: '手机号不能为空',
                    trigger: 'blur'
                }],
            },
            header: {},
            headers: {
                token: localStorage.getItem('token')
            },
            loading: false,
            queryParams: {
                page: 1,
                pagesize: 10,
            },
            pageInfo: {},


            uphtml: '',
            uploadUrl: "/i/admin/wallet/mealcard/rechargeByImport",
            fileList: [],
            dialogVisibleImport: false,
            uplosuccess: false,
            exampleTableHeaderData: [
                {ordersn: 'M202501011234567890', card_no: '138000',amount: '100.00',state:"充值失败",remark:"余额不足"},
                {ordersn: 'M202501011234567891', card_no: '138001',amount: '100.00',state:"已充值",remark:""},
                {ordersn: 'M202501011234567892', card_no: '138001',amount: '200.00',state:"已充值",remark:""},
            ]

        }
    },
    created() {
        this.header.token = localStorage.getItem('token');
        this.header.platform = 'admin';
        this.loadData()
    },
    methods: {
        // 导出
        exportFile() {
            //if (this.queryParams.ctime && this.queryParams.etime) {
            request.post('/wallet/mealcard/recharge/export', {
                stime: this.queryParams.ctime,
                etime: this.queryParams.etime
            }).then(ret => {
                if (ret.code === 1) {
                    this.$message.success('导出成功，请到菜单： 系统设置 -> 下载 点击下载');
                    } else {
                        this.$message.error(ret.msg);
                    }
                });
            //} else {
            //    this.$message.error('请选择时间');
            //}

        },


        // 导入弹窗关闭
        upclose() {
            this.headers = {
                session_id: null,
            };

            this.fileList = [];

        },

        add() {
            this.mode = 'add';
            this.title = '新增';
            this.form = {
                state: 0,
                sex: 1
            };
            this.addVisible = true;
            if (this.$refs.form) {
                this.$refs.form.clearValidate()
            }
        },
        //图片上传
        handleAvatarSuccess(res, file) {
            if (res.code == 1) {
                loads.close()
                this.$set(this.form, 'avatar', res.data.uri);
            }
        },
        handleAvatarError(err,file,fileList) {
            console.log( err)
            console.log( file)
            console.log( fileList)

        },
        beforeAvatarUpload(file) {
            loads.open('.avatar-uploader .el-upload', '上传中')
            const _this = this
            return deal.imageFormat(file, _this, 300)
        },
        //状态
        state(row, state) {
            if (state == 2) {
                this.confirmContent = '确定是否启用?';
            } else {
                this.confirmContent = '确定是否禁用?';
            }
            this.form = Object.assign({}, row);
            this.form.state = state;
            this.form.ctime = deal.timestamp(this.form.ctime);
            this.form.etime = deal.timestamp(this.form.etime);
            this.confirmVisible = true;
        },

        //详情
        xiangqi(index, row) {
            this.$router.push({path: '/custom-Detail', query: {id: row.id}})
        },
        //编辑
        edit(index, row) {
            this.selectDistributor = {}
            this.mode = 'edit';
            this.title = '编辑客户';
            this.current = row.id;
            const item = this.pageInfo.list[index];
            //处理时间
            this.form = Object.assign({}, item);
            this.$set(this.form);
            this.form.agent_id = this.form.agent_id + ''
            this.addVisible = true;
            // 载入关联的分销商
        },
        // 编辑新增
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        var url = '/wallet/mealcard/recharge/edit';

                        //处理时间
                        request.post(url, this.form).then(ret => {
                            if (ret.code === 1) {
                                this.addVisible = false;
                                this.loadData();
                                this.$message.success((this.mode === 'add' ? '新增' : '编辑') +
                                    '成功');
                                this.$refs.form.clearValidate()
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$message.error('请补全信息');
                        return false;
                    }
                });
            }
            ;
        },
        loadData() {
            this.loading = true;

            request.get('/wallet/mealcard/recharge/list', this.queryParams).then(ret => {

                if (ret.code === 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                } else {
                    this.loading = false;
                    this.$message.error(ret.msg);
                }
            });
        },
        // 确定禁用
        stateData() {
            request.post('/account/edit', this.form).then(ret => {
                if (ret.code === 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //选择商品
        selectgoods(selection, row) {
            this.selectionList = selection

        },
        changeQuery() {
            this.queryParams.page = 1
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            }
            this.loadData()
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            }
            this.loadData()
        },
        refreshPageNum(val) {
            this.queryParams.page = val
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            }
            this.loadData()
        },



        //监听子组件 提交的分销商的id
        listenChoiceDistributor(distributor) {
            console.log("--------listenChoiceDistributor---------")
            console.table(distributor)
            this.selectDistributor = distributor
        },
        // 导入数据===========
        chanuploat(file, fileList) {
            console.log(file, fileList)
        },
        submitUpload() {
            this.$refs.upload.submit();
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        }

    }
}

</script>

<style scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}

/* 对话框样式 */

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}

/* 图片样式 */
.dialog_box .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
.warning-text{
 color:#E6A23C;
}

.dialog_box .avatar {
    font-size: 28px;
    width: 100px;
    height: 100px;
    line-height: 100px;
}

.dialog_box .span_gray {
    font-size: 12px;
    color: gray;
}

.dialog_box .up {
    margin-top: 10px;
    margin-bottom: -10px;
}

/* 选择链接样式 */
.dialog_box .el-button {
    margin-left: 20px;
}

.distributor-name {
    font-size: 20px;
    font-weight: bold;
}
</style>
